import React, { useContext, useState } from 'react';
//
const CouponContext = React.createContext({
  id: null,
  setCouponId: (id: string) => {
    return;
  },
});

export const CouponProvider = ({ children }) => {
  const [id, setId] = useState(null);

  const setCouponId = (id) => {
    setId(id);
  };
  return (
    <CouponContext.Provider value={{ id, setCouponId }}>
      {children}
    </CouponContext.Provider>
  );
};

const useCoupon = () => {
  const context = useContext(CouponContext);

  if (!context)
    throw new Error('Coupon context must be use inside CouponProvider');

  return context;
};

export default useCoupon;
